import { createSelector } from '@reduxjs/toolkit';

import { selectReadyBusinessTypes } from 'shared/selectors/jsonQuery';

import { READY_BUSINESS_TYPES_OPTIONS } from './selectReadyBusinessTypesOptions';

const DEFAULT_LABEL = 'Тип бизнеса';

export const selectReadyBusinessTypesLabel = createSelector(selectReadyBusinessTypes, values => {
  if (!values || values.length === 0) {
    return DEFAULT_LABEL;
  }

  const labels = values
    .map(value => READY_BUSINESS_TYPES_OPTIONS.find(opt => opt.value === value)?.label)
    .filter(Boolean);

  if (labels.length === 0) {
    return DEFAULT_LABEL;
  }

  return labels.join(', ');
});
